import React from 'react';

export const HrInWell = props => <hr style={{borderTop: '1px solid rgb(221, 221, 221)', ...props.style}} />;

export const HrBetweenWell = props => <hr style={{marginBottom: 15, ...props.style}} />;


// WEBPACK FOOTER //
// ./src/commonComponents/Dividers.jsx